'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _HubCalcEditionSelectionContainer = require('pricing-pages-unified-ui/components/calculator/HubCalcEditionSelectionContainer');

var _HubCalcEditionSelectionContainer2 = _interopRequireDefault(_HubCalcEditionSelectionContainer);

var _AdditionalUnitsPicker = require('pricing-pages-unified-ui/components/calculator/AdditionalUnitsPicker');

var _AdditionalUnitsPicker2 = _interopRequireDefault(_AdditionalUnitsPicker);

var _HubCalcRequiredOnboardingSectionContainer = require('pricing-pages-unified-ui/components/calculator/HubCalcRequiredOnboardingSectionContainer');

var _HubCalcRequiredOnboardingSectionContainer2 = _interopRequireDefault(_HubCalcRequiredOnboardingSectionContainer);

var _PlanSelectorTileHeader = require('./PlanSelectorTileHeader');

var _PlanSelectorTileHeader2 = _interopRequireDefault(_PlanSelectorTileHeader);

var _CodeSplitEnvWrapper = require('pricing-pages-unified-ui/components/CodeSplitEnvWrapper');

var _CodeSplitEnvWrapper2 = _interopRequireDefault(_CodeSplitEnvWrapper);

var _Calculator = require('pricing-pages-unified-ui/components/calculator/Calculator');

var _ActiveHubSelectors = require('pricing-pages-unified-ui/selectors/ActiveHubSelectors');

var _merchUtils = require('self-service-api/core/utilities/merchUtils');

var _ItemConfigsSelectors = require('pricing-pages-unified-ui/selectors/ItemConfigsSelectors');

var _Hubs = require('self-service-api/constants/Hubs');

var _Hubs2 = _interopRequireDefault(_Hubs);

var _Terms = require('self-service-api/constants/Terms');

var _CalculatorDivider = require('pricing-pages-unified-ui/components/calculator/CalculatorDivider');

var _CalculatorDivider2 = _interopRequireDefault(_CalculatorDivider);

var _stateUtils = require('pricing-pages-unified-ui/utils/stateUtils');

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HubCalcPlanSelectorTileContainer = function HubCalcPlanSelectorTileContainer(_ref) {
  var activeHub = _ref.activeHub,
      getAvailableTerms = _ref.getAvailableTerms;

  var _useContext = (0, _react.useContext)(_Calculator.CalculatorContext),
      state = _useContext.state,
      mergeState = _useContext.mergeState;

  var activeEdition = state.activeEdition,
      activeTerm = state.activeTerm,
      selectedAddOns = state.selectedAddOns;

  var unitsKey = activeHub + 'Units';
  var additionalUnitQuantity = state[unitsKey];
  var activeMerchId = (0, _merchUtils.getHighlightedMerchIdForEdition)(activeHub, activeEdition);

  var getDefaultTerm = function getDefaultTerm(edition) {
    var merchandiseId = (0, _merchUtils.getHighlightedMerchIdForEdition)(activeHub, edition);
    var availableTerms = getAvailableTerms(merchandiseId);
    return availableTerms.monthly ? _Terms.MONTHLY : _Terms.ANNUAL;
  };

  var setActiveEdition = function setActiveEdition(edition) {
    var _mergeState;

    var filteredAddons = (0, _stateUtils.filterInvalidAddons)(selectedAddOns.toArray(), activeHub, activeEdition, edition);

    mergeState((_mergeState = {
      activeEdition: edition
    }, _defineProperty(_mergeState, unitsKey, 0), _defineProperty(_mergeState, 'activeTerm', getDefaultTerm(edition)), _defineProperty(_mergeState, 'selectedAddOns', (0, _immutable.Set)(filteredAddons)), _mergeState));
  };

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      _PlanSelectorTileHeader2.default,
      null,
      _react2.default.createElement(_CodeSplitEnvWrapper2.default, {
        authedComponentLoader: function authedComponentLoader() {
          return import( /* webpackChunkName: "authed-chunk" */'pricing-pages-unified-ui/components/calculator/CalcTermSelectorContainer');
        },
        authedComponentProps: {
          activeTerm: activeTerm,
          merchandiseId: activeMerchId,
          onChange: function onChange(term) {
            return mergeState({ activeTerm: term });
          }
        }
      })
    ),
    _react2.default.createElement(_HubCalcEditionSelectionContainer2.default, {
      activeEdition: activeEdition,
      setActiveEdition: setActiveEdition
    }),
    _react2.default.createElement(_HubCalcRequiredOnboardingSectionContainer2.default, {
      term: activeTerm,
      merchandiseId: activeMerchId
    }),
    _react2.default.createElement(_CalculatorDivider2.default, null),
    _react2.default.createElement(_AdditionalUnitsPicker2.default, {
      hub: activeHub,
      merchandiseId: activeMerchId,
      term: activeTerm,
      additionalUnitQuantity: additionalUnitQuantity,
      setAdditionalUnitQuantity: function setAdditionalUnitQuantity(quantity) {
        return mergeState(_defineProperty({}, unitsKey, quantity));
      },
      setActiveEdition: setActiveEdition
    }),
    _react2.default.createElement(_CalculatorDivider2.default, null),
    _react2.default.createElement(_CodeSplitEnvWrapper2.default, {
      authedComponentLoader: function authedComponentLoader() {
        return import( /* webpackChunkName: "authed-chunk" */'pricing-pages-unified-ui/components/calculator/AddonsAndServices/AddonsAndServices');
      },
      publicComponentLoader: function publicComponentLoader() {
        return import( /* webpackChunkName: "public-chunk" */'pricing-pages-unified-ui/components/calculator/AddonsAndServices/AddonsAndServicesList');
      },
      publicComponentProps: { hub: activeHub, edition: activeEdition }
    })
  );
};

HubCalcPlanSelectorTileContainer.propTypes = {
  activeHub: _react.PropTypes.oneOf(Object.values(_Hubs2.default || {})),
  getAvailableTerms: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeHub: (0, _ActiveHubSelectors.activeHubSelector)(state),
    getAvailableTerms: function getAvailableTerms(merchandiseId) {
      return (0, _ItemConfigsSelectors.availableTermsForMerchSelector)(state, merchandiseId);
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(HubCalcPlanSelectorTileContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/HubCalcPlanSelectorTileContainer.js
// module id = 336
// module chunks = 3 4